import axios from 'axios';
import { getEnvVariables } from 'helpers/getEnvVariables';

const { QUOTER_URL } = getEnvVariables()

export const quoter = async (data) => {
    try {

        const response = await axios.post(`${QUOTER_URL}/rate-engine/compute`, data);
        return await response.data;

    } catch (error) {
        console.log(error.response.data.message)
    }
};

export const findQuoterByApQuoteId = async (apQuoteId) => {
    try {

        const response = await axios.get(`${QUOTER_URL}/rate-engine/compute/apQuoteId/${apQuoteId}?withContext=true`);
        return await response.data;

    } catch (error) {
        console.log(error.response.data.message)
    }
};
